/**
 * Onboarding store — new_report badge (localStorage, ephemeral per-device).
 * Onboarding completion and step are stored in DB via /api/user/onboarding.
 */

const KEY_NEW_REPORT = "ripenn_onboarding_new_report";

export type OnboardingStep = "domain" | "extract" | "approve-brand" | "prompts";

export function getNewReportReady(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(KEY_NEW_REPORT) === "true";
}

export function setNewReportReady(value: boolean): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY_NEW_REPORT, value ? "true" : "false");
  window.dispatchEvent(new CustomEvent("ripenn:onboardingUpdate"));
}

export function clearNewReportReady(): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY_NEW_REPORT, "false");
  window.dispatchEvent(new CustomEvent("ripenn:onboardingUpdate"));
}
